import { useEffect, useContext, useCallback } from 'react';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import useSessionStorage from '../../hooks/useSessionStorage.js';
import { LearnosityContainerObservable } from '../assessment/LearnosityContainer.js';
import { LEARNOSITY_EVENTS } from '../../scripts/learnosityScripts.js';
import * as PwaEvents from '../../context/PwaEvents.js';
import { TESTER_SAVE_DIALOG } from '../assessment/LearnosityDialogs.js';
import { SecureWrapperObservable } from '../secure-wrapper/SecureWrapper.js';
import { sleep } from '../../scripts/common/helper.js';

const PreviewEventHandler = () => {
  const {
    updateLaunchError,
    setExit,
    setOpenExitingDialog,
    setExitingDialogDetails,
  } = useContext(AssessmentContext);
  const { clearStorage } = useSessionStorage();
  const isPreview = window.location?.pathname?.startsWith('/authorform');
  const testerSaveAndExitSuccess = useCallback((timedExit) => {
    if(timedExit) {
      const dialog = TESTER_SAVE_DIALOG();
      setExitingDialogDetails(dialog);
      setOpenExitingDialog(true);
    } else {
      //Secure wrapper exit - no countdown dialog to close, so exit on a timer
      //to give the pause/save events time to finish.
      setTimeout(() => {
        setExit(true);
      }, 8000);
    }

  }, [setOpenExitingDialog, setExitingDialogDetails]);

  const eventHandler = useCallback(
    async ({ eventName, ...more }) => {
      switch (eventName) {
        case LEARNOSITY_EVENTS.TEST_SUBMIT_SUCCESS:
          //We do not want to exit out of waypoint on test submit success
          //the test:finished:submit will take care of exit
          clearStorage();
          break;
        case PwaEvents.TESTER_SAVEANDEXIT: //This event is generated by NMC custom Save/Exit button
          if (isPreview) {
            window.close(); //close immediately
          } else {
            testerSaveAndExitSuccess(more.timedExit);
          }
          break;
        case LEARNOSITY_EVENTS.TEST_FINISHED_SAVE: //This event is generated by Learnosity Save/Exit button
        case LEARNOSITY_EVENTS.TEST_FINISHED_SUBMIT:
          setExit(true);
          break;
        case PwaEvents.LEARNOSITY_LAUNCH_FAIL:
          updateLaunchError(true);
          break;
        default:
          break;
      }
    },
    [
      updateLaunchError,
      testerSaveAndExitSuccess,
      clearStorage,
      setExit,
      isPreview,
    ]
  );

  //UseEffect required. Subscribe and unsubscribe here
  //to make sure the event handler is registered and unregistered
  useEffect(() => {
    //priority on subscribe will call the methods in priority order
    //otherwise it will get invoked in the order of subscription
    LearnosityContainerObservable.subscribe(
      eventHandler,
      'practiceTestEventHandler'
    );
    //Secure wrapper save/exit events go through the same handler, priority 
    //it will get invoked in the order of subscription
    SecureWrapperObservable.subscribe(eventHandler, 'practiceTestEventHandler');
    return () => {
      LearnosityContainerObservable.unsubscribe('practiceTestEventHandler');
      SecureWrapperObservable.unsubscribe(eventHandler, 'practiceTestEventHandler');
    };
  }, [eventHandler]);

  return <></>;
};
export default PreviewEventHandler;
